import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GetProductQueryResponse, GetSuppliersQueryResponse, CreateProductCommand, UpdateProductCommand, GetUsersQueryResponse } from '../../interfaces/interfaces';
import { ProductsService } from '../products.service';
import { SuppliersService } from 'src/app/suppliers/suppliers.service';
import { AuthService } from 'src/app/services/auth.service';
import { StreamingService } from 'src/app/services/streaming.service';
import { take } from 'rxjs/operators';
import { map, Observable } from 'rxjs';
import { AdaptiveMode } from '@progress/kendo-angular-dateinputs';
import { DatePipe } from '@angular/common';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { environment } from 'src/environments/environment';
import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';

@Component({
  selector: 'sdc-reorder-product',
  templateUrl: './reorder-product.component.html',
  styleUrls: ['./reorder-product.component.scss']
})
export class ReOrderProductComponent implements OnInit {
  @ViewChild('viewer1') viewer: TelerikReportViewerComponent;

  isLoading = true;
  isUpdate = false;
  productForm: UntypedFormGroup;
  processDate = false;
  userName: string;
  role: string;

  public isDiamondsChecked = true;
  public isStockReOrderedChecked = true;

  currentDate = new Date();
  createJewelleryCommand: CreateProductCommand;
  updateJewelleryCommand: UpdateProductCommand;

  public myFiles: Array<File>;


  public label1 = '';
  public label2 = '';
  public label3 = '';
  public label4 = '';
  public label5 = '';
  public label6 = '';

  public gridData: Observable<any>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 5,
  };
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };

  public allowCustom = true;
  public selectedValuesMetal: string = "Default";
  public listItemsMetal: Array<string> = [
    "Default",
  ];

  public selectedValues: string = "Cash";
  public listItemsPaymentMethod: Array<string> = [
    "Cash",
    "Debit/Credit Card",
    "Other",
  ];

  public valueStockDate: Date = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), (new Date()).getHours());
  public valueStockReOrderDate: Date = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), (new Date()).getHours());
  public format = "MM/dd/yyyy HH:mm";
  public adaptiveMode: AdaptiveMode = "auto";

  public selectedValuesSupplier: string = "Default";
  public listItemsSupplier: Array<string> = [
    "Default",
  ];

  public viewerContainerStyle =  {   
    position:  'relative',   
    width:  '800px',   
    height:  '600px', 
    left: '5px',
    right: '5px',   
    ['font-family']:  'ms sans serif'    
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public jewellery: GetProductQueryResponse,
    public dialogRef: MatDialogRef<ReOrderProductComponent>,
    private productService: ProductsService,
    private streamingService: StreamingService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private matSnackBar: MatSnackBar,
    private supplierService: SuppliersService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) {
    if (this.jewellery.id > 0) {
      this.isUpdate = true;
      this.valueStockDate = new Date(this.jewellery.stockCountDate);
      this.valueStockReOrderDate = new Date(this.jewellery.stockReOrderAmountLastBoughtDate);
    }
   }

   ngOnInit(): void {
    this.userName = localStorage.getItem('currentUserName');
    //this.role = localStorage.getitem('currentRole');
    this.productForm = this.formBuilder.group({
      title: [null, Validators.required],
      description: [null],
      costPrice: [null, Validators.required],
      itemsPerUnit: [null],
      stockCount: [null, Validators.required],
      stockCountBy: [null],
      //stockCountDate: [null],
      stockAlert: [null, Validators.required],
      stockWarning: [null, Validators.required],
      stockReOrderAmountLastBought: [null],
      //stockReOrderAmountLastBoughtDate: [null],
      stockReOrderAmountSuggested: [null],
      stockReOrdered: [null],
      stockReOrderedBy: [null],
    },);

    this.listItemsSupplier = [];
    this.supplierService.getAllSuppliers().pipe(take(1)).subscribe({
      next: (response: GetSuppliersQueryResponse) => {
        for (var i = 0; i < response.suppliers.length; i ++)
        {
          //this.listItemsCustomer.push('id:' + response.customers[i].id + ', name: ' + response.customers[i].name);
          this.listItemsSupplier.push(response.suppliers[i].title + ' ,' + response.suppliers[i].id);
        }
        //this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        //this.isLoading = false;
      }
    });

    if (this.isUpdate) {
      this.productService.getProduct({id : this.jewellery.id}).pipe(take(1)).subscribe({
        next: (response: GetProductQueryResponse) => {
          //this.repair = response;
          //alert(response.stockCountDate + ' ' + response.stockReOrderAmountLastBoughtDate);
          if (response.stockCountDate != undefined) {
            response.stockCountDate = new Date(response.stockCountDate).toDateString();        
          }
          if (response.stockReOrderAmountLastBoughtDate != undefined) {
            response.stockReOrderAmountLastBoughtDate = new Date(response.stockReOrderAmountLastBoughtDate).toDateString();        
          }
          console.log(response);
          this.productForm.patchValue(response);
          //alert("After reponse Patch");
          this.isStockReOrderedChecked = response.stockReOrdered;
          this.selectedValuesSupplier = response.supplierName + ', ' + response.supplierId;
          //alert(this.selectedValuesSupplier);
          //this.repairForm.controls.dateStarted.setValue = new Date(this.repair.dateStarted);
          const count = {};
          //alert(response.photos);
        },
        error: (error: HttpErrorResponse) => {
          alert(error);
          this.isLoading = false;
        }
      });
      
    }
    else {
    }
    this.isLoading = false;
  }

  public parseObjectDates(target: any): any {
    const result = Object.assign({}, target);

    Object.keys(result).forEach((key) => {
      const date = new Date(result[key]);
      if (!isNaN(date.getTime())) {
        result[key] = date;
      }
    });

    return result;
  }

  public onSizeChangeSupplier(value) {
    this.selectedValuesSupplier = value;
  }

  onStockCheckboxChange(e) {
    if (e.target.checked) {
      this.isStockReOrderedChecked = true;
    } else {
      this.isStockReOrderedChecked = false;
    }
  }

  addProduct(): void {
    this.isLoading = true;
    this.createJewelleryCommand = this.productForm.value;

    var save = false;
    if (this.selectedValuesSupplier == 'Default')
    {
        save = false;
        alert("Supplier not selected!");
    }
    else {
      // save id of customer from drop down into id field for buyIn
      this.createJewelleryCommand.supplierName = this.selectedValuesSupplier.slice(0, this.selectedValuesSupplier.indexOf(','));
      this.createJewelleryCommand.supplierId = Number(this.selectedValuesSupplier.slice(this.selectedValuesSupplier.indexOf(',') + 1));
      save = true;
    }

    this.createJewelleryCommand.stockCountDate = this.datePipe.transform(this.valueStockDate, 'yyyy-MM-dd HH:mm');
    this.createJewelleryCommand.stockReOrderAmountLastBoughtDate = this.datePipe.transform(this.valueStockReOrderDate, 'yyyy-MM-dd HH:mm');
    this.createJewelleryCommand.stockReOrdered = this.isStockReOrderedChecked;

    if (save)
    {
    
      this.authService.getAllUsers().pipe(take(1)).subscribe({
        next: (response: GetUsersQueryResponse) => {     
          var userExist = true; //response.users.filter(x => x.password == pass && x.role == 'Admin') ;
          //alert(pass);
          //alert(userExist);
          if (userExist == true)
          {
            this.productService.createProduct(this.createJewelleryCommand).pipe(take(1)).subscribe({
              next: () => {
                this.isLoading = false;
                this.displayMessage('New supplier created');
                this.dialogRef.close();
              },
              error: (error: HttpErrorResponse) => {
                alert(error);
                this.isLoading = false;
              }
            });
          }
          else
          {
            alert("User password is not a valid Admin User! Information not saved!");
            this.isLoading = false;
          }
        },
          error: (error: HttpErrorResponse) => {
            alert("Authentication error: " + error);
            this.isLoading = false;
          }
        });
    }
  }

  updateProduct(): void {
    this.isLoading = true;
    this.updateJewelleryCommand = this.productForm.value;

    var save = false;
    if (this.selectedValuesSupplier == 'Default')
    {
        save = false;
        alert("Supplier not selected!");
    }
    else {
      // save id of customer from drop down into id field for buyIn
      this.updateJewelleryCommand.supplierName = this.selectedValuesSupplier.slice(0, this.selectedValuesSupplier.indexOf(','));
      this.updateJewelleryCommand.supplierId = Number(this.selectedValuesSupplier.slice(this.selectedValuesSupplier.indexOf(',') + 1));
      save = true;
    }

    this.updateJewelleryCommand.stockCountDate = this.datePipe.transform(this.valueStockDate, 'yyyy-MM-dd HH:mm');
    this.updateJewelleryCommand.stockReOrderAmountLastBoughtDate = this.datePipe.transform(this.valueStockReOrderDate, 'yyyy-MM-dd HH:mm');
    this.updateJewelleryCommand.stockReOrdered = this.isStockReOrderedChecked;

    if (save)
    {
      this.authService.getAllUsers().pipe(take(1)).subscribe({
        next: (response: GetUsersQueryResponse) => {     
          var userExist = true; //response.users.filter(x => x.password == pass && x.role == 'Admin') ;
          //alert(pass);
          //alert(userExist);
          if (userExist)
          {
            this.updateJewelleryCommand.id = this.jewellery.id;
            //alert(this.repairForm.controls.myFiles.value);

            this.updateRepairEvent(this.updateJewelleryCommand);
            this.isLoading = false;
          }
          else
          {
            alert("User password is not a valid Admin User! Information not saved!");
            this.isLoading = false;
          }
        },
          error: (error: HttpErrorResponse) => {
            alert("Authentication error: " + error);
            this.isLoading = false;
          }
        }); 
    }
  }

  updateRepairEvent(command: UpdateProductCommand): void {
    this.productService.updateProduct(command).pipe(take(1)).subscribe({
      next: () => {
        this.isLoading = false;
        this.displayMessage('Supplier updated');
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        this.isLoading = false;
      }
    });
    
  }

  private displayMessage(message: string): void {
    this.matSnackBar.open(message, 'Close', {
      duration: 7000
    });
  }
}
